const enum HeaderType {
  Name,
  Memo,
  Time,
  LastDetectedDevice,
  LastEventLogName,
  BatteryLifeRessetedAt,
  Status,
}

export default HeaderType
